var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDb2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9faf1",
      stroke: "none"
    },
    d: "M0 0L0 500L500 500L500 0L0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cc6bc3",
      stroke: "none"
    },
    d: "M241 16.5178C194.085 26.5271 210.693 99.3617 257 89.4822C305.05 79.2308 288.806 6.31851 241 16.5178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9faf1",
      stroke: "none"
    },
    d: "M243 24.5178C206.664 32.2817 218.864 89.0384 255 81.331C292.735 73.2828 280.334 16.5405 243 24.5178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cc6bc3",
      stroke: "none"
    },
    d: "M190.995 86.6674C164.709 91.1013 135.186 112.502 117.039 131.015C110.853 137.326 104.33 144.432 99.7153 152C98.0921 154.662 96.0539 159.986 101.02 160.534C104.403 160.907 106.623 157.259 108.424 154.995C113.348 148.811 118.372 142.574 124.004 137.015C137.067 124.118 152.569 113.024 169 104.809C176.117 101.25 190.084 99.0575 195.392 93.2979C198.618 89.7976 194.899 86.0089 190.995 86.6674M306.148 86.9267C301.333 88.4145 303.914 93.3741 307.059 94.892C333.439 107.626 356.762 117.661 377.999 139C383.332 144.358 387.913 150.238 392.804 155.981C394.344 157.789 396.874 161.167 399.681 159.824C402.906 158.282 400.866 154.091 399.597 152C395.446 145.156 389.479 138.762 383.961 133C368.199 116.543 348.152 102.241 327 93.6034C321.876 91.5109 311.745 85.1974 306.148 86.9267M220 97.4283C191.496 101.501 176 123.141 176 151C176 156.279 173.505 170.58 178.434 173.972C185.359 178.739 205.642 175 214 175L288 175C298.294 175 312.017 177.407 321.941 174.682C328.196 172.965 326 161.919 326 157C326 139.708 324.463 122.782 310.961 110.174C302.764 102.519 285.678 93.8448 274 97.5633C265.711 100.203 260.546 107.137 251 106.87C239.185 106.54 231.856 95.7343 220 97.4283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ca435",
      stroke: "none"
    },
    d: "M342 101L343 102L342 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9faf1",
      stroke: "none"
    },
    d: "M318 167C318 141.484 313.95 102.505 278 105.727C268.2 106.605 261 115.397 250 114.896C240.396 114.459 234.574 108.444 226 106.013C218.454 103.874 208.165 108.008 202 112.105C188.254 121.241 184.001 136.371 184 152C184 155.476 182.522 163.532 185.603 165.972C189.439 169.01 200.295 167 205 167L259 167L318 167z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ca435",
      stroke: "none"
    },
    d: "M352 107L353 108L352 107M338 108L339 109L338 108M355 109L356 110L355 109M362 114L363 115L362 114M351 116L352 117L351 116M366 117L367 118L366 117M358 121L359 122L358 121M373 123L374 124L373 123M374 124L375 125L374 124M321 125L322 126L321 125M363 125L364 126L363 125M368 129L369 130L368 129M369 130L370 131L369 130M388 138L389 139L388 138M389 139L390 140L389 139M390 140L391 141L390 140M382 143L383 144L382 143M383 144L384 145L383 144M384 145L385 146L384 145M394 145L395 146L394 145M395 146L396 147L395 146M388 150L389 151L388 150M398 150L399 151L398 150M389 151L390 152L389 151M400 153L401 154L400 153M401 154L402 155L401 154M392 155L393 156L392 155M393 156L394 157L393 156M402.333 156.667L402.667 157.333L402.333 156.667M395 159L396 160L395 159M401 159L402 160L401 159M396 160L397 161L396 160M400 160L401 161L400 160z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cc6bc3",
      stroke: "none"
    },
    d: "M88 168.439C39.7119 176.043 51.2688 250.077 99 242.561C146.84 235.028 135.565 160.949 88 168.439z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ca435",
      stroke: "none"
    },
    d: "M395 169L395 170L398 170L395 169z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cc6bc3",
      stroke: "none"
    },
    d: "M377 231C381.432 219.389 370.695 209.477 375.468 197C380.74 183.22 396.72 181.502 401 169C373.384 172.566 351.288 209.694 377 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ca435",
      stroke: "none"
    },
    d: "M398 177C409.708 177 418.904 179.213 426.471 189.001C440.304 206.897 427.608 231.838 406 234.696C394.402 236.23 388.399 228.357 379 224C375.257 237.287 390.082 242.873 402 242.996C418.284 243.165 433.417 233.855 438.641 218C443.398 203.566 439.528 186.198 426.996 176.761C418.577 170.421 401.923 162.857 398 177M392 170L393 171L392 170M389 171L390 172L389 171M387 172L388 173L387 172M385 173L386 174L385 173M383 174L384 175L383 174z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9faf1",
      stroke: "none"
    },
    d: "M91 176.443C54.0892 180.838 57.6336 237.876 95 234.671C133.176 231.397 128.741 171.949 91 176.443z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ca435",
      stroke: "none"
    },
    d: "M380 176L381 177L380 176M379 177L380 178L379 177M395 177L396 178L395 177z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9faf1",
      stroke: "none"
    },
    d: "M396 177.529C360.017 185.789 373.347 241.935 409 234.331C447.317 226.159 433.575 168.904 396 177.529z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ca435",
      stroke: "none"
    },
    d: "M378 178L379 179L378 178M392 178L393 179L392 178M390 179L391 180L390 179M388 180L389 181L388 180M374 182L375 183L374 182M385 182L386 183L385 182M373 183L374 184L373 183M384 183L385 184L384 183M383 184L384 185L383 184M382 185L383 186L382 185M371 186L372 187L371 186M381 186L382 187L381 186M380 187L381 188L380 187M370 188L371 189L370 188M369 190L370 191L369 190M378 190L379 191L378 190z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cc6bc3",
      stroke: "none"
    },
    d: "M200 192L201 193L200 192z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0707ff",
      stroke: "none"
    },
    d: "M192 250L195 250L195 245L207 245L207 250C212.545 249.816 214.101 245.808 219.015 244.434C222.783 243.38 227.29 244.967 230.771 242.821C233.041 241.421 234.087 238.586 232.353 236.317C228.485 231.258 212.789 234 207 234L207 238L196 239L195 221C209.492 221 250.154 214.811 247.439 240C247.061 243.508 245.315 246.778 244 250L249 250L249 192C235.443 192 204.825 186.302 195.148 197.044C191.095 201.544 192 207.368 192 213L192 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ca435",
      stroke: "none"
    },
    d: "M249 192L250 308L285 308C290.238 308 296.578 309.085 300.985 305.682C309.444 299.149 308 289.492 308 280L308 220C308 211.018 309.481 201.759 301.957 195.228C297.165 191.07 290.913 192 285 192L249 192z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cc6bc3",
      stroke: "none"
    },
    d: "M197 194L198 195L197 194M196 195L197 196L196 195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ca435",
      stroke: "none"
    },
    d: "M367.333 195.667L367.667 196.333L367.333 195.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cc6bc3",
      stroke: "none"
    },
    d: "M195 196L196 197L195 196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ca435",
      stroke: "none"
    },
    d: "M375 196L376 197L375 196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cc6bc3",
      stroke: "none"
    },
    d: "M194 197L195 198L194 197M193 198L194 199L193 198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ca435",
      stroke: "none"
    },
    d: "M374.333 199.667L374.667 200.333L374.333 199.667M366.333 200.667L366.667 201.333L366.333 200.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cc6bc3",
      stroke: "none"
    },
    d: "M191 202L191 298L192 298L192 231L191 202z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ca435",
      stroke: "none"
    },
    d: "M366 207L366 211L367 211L366 207M374.333 210.667L374.667 211.333L374.333 210.667M367.333 214.667L367.667 215.333L367.333 214.667M375.333 214.667L375.667 215.333L375.333 214.667M376 217L377 218L376 217M368 218L369 219L368 218M377 219L378 220L377 219M369 220L370 221L369 220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cc6bc3",
      stroke: "none"
    },
    d: "M195 221L195 222L234 222C223.726 217.689 206.172 221 195 221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9faf1",
      stroke: "none"
    },
    d: "M251 221L251 233L288 234C275.486 251.003 251 255.49 251 279L303 279L303 267L277 267C274.955 266.996 269.197 267.704 268.631 264.772C267.863 260.792 279.301 253.833 282 251.586C293.778 241.783 303 237.04 303 221L251 221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ca435",
      stroke: "none"
    },
    d: "M378 221L379 222L378 221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9faf1",
      stroke: "none"
    },
    d: "M195 222L195 238L207 238L207 233C213.522 233 222.864 231.296 228.981 233.742C232.093 234.987 234.724 238.432 232.238 241.566C228.145 246.729 214.296 240.487 214.296 250.011C214.296 259.244 227.3 253.691 231.663 258.318C234.54 261.369 232.432 265.064 228.981 266.397C222.9 268.745 213.475 267 207 267L207 246L195 246L195 278C206.803 278 228.715 282.196 238.996 275.991C250.729 268.909 244.628 260.079 244.628 250C244.628 240.031 250.613 231.044 238.995 224.009C228.736 217.797 206.787 222 195 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ca435",
      stroke: "none"
    },
    d: "M370 222L371 223L370 222M379 222L380 223L379 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cc6bc3",
      stroke: "none"
    },
    d: "M238 223L239 224L238 223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ca435",
      stroke: "none"
    },
    d: "M371 224L372 225L371 224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cc6bc3",
      stroke: "none"
    },
    d: "M242 226L243 227L242 226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ca435",
      stroke: "none"
    },
    d: "M372 226L373 227L372 226M373 227L374 228L373 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cc6bc3",
      stroke: "none"
    },
    d: "M245 230L246 231L245 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ca435",
      stroke: "none"
    },
    d: "M375 230L376 231L375 230M245 231L246 232L245 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cc6bc3",
      stroke: "none"
    },
    d: "M207 233L207 234L230 234L207 233M246 233L247 234L246 233M231 234L232 235L231 234M232 235L233 236L232 235M233 236L234 237L233 236M247 236L247 241L248 241L247 236M196 238L197 239L196 238M233 240L234 241L233 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ca435",
      stroke: "none"
    },
    d: "M232 242L233 243L232 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cc6bc3",
      stroke: "none"
    },
    d: "M230 243L231 244L230 243M217 244L218 245L217 244M246 244L247 245L246 244M195 245L195 246L207 246L195 245M215 245L216 246L215 245M214 246L215 247L214 246M245 246L246 247L245 246M213 248L214 249L213 248M244 248L245 249L244 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ca435",
      stroke: "none"
    },
    d: "M213 249L214 250L213 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cc6bc3",
      stroke: "none"
    },
    d: "M243 249L245 252L243 249M60 250.464C32.2556 255.366 20 279.029 20 305C20 310.141 17.6172 323.506 22.4336 326.821C29.5286 331.704 49.4859 328 58 328L132 328C142.124 328 156.209 330.548 165.891 327.566C172.103 325.653 170 314.971 170 310C170 291.234 167.966 274.4 152.999 261.184C144.496 253.676 128.559 246.864 117 250.563C108.116 253.406 103.197 259.406 93 258.959C80.3891 258.406 73.4938 248.079 60 250.464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff0505",
      stroke: "none"
    },
    d: "M192 250L192 287C192 292.632 191.095 298.456 195.148 302.956C204.825 313.698 235.443 308 249 308L249 250L244 250C245.318 253.231 247.038 256.487 247.442 260C250.367 285.45 209.757 279 195 279L195 250L192 250M207 250L207 267C213.015 267 228.074 269.715 232.242 264.566C239.377 255.754 221.26 256.63 218.043 255.397C213.449 253.637 212.412 250.18 207 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cc6bc3",
      stroke: "none"
    },
    d: "M213.333 250.667L213.667 251.333L213.333 250.667M249 250L249 308L250 308L250 269L249 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ca435",
      stroke: "none"
    },
    d: "M368 251L365 261C380.425 256.11 388.898 267.469 404 267.957C415.386 268.324 423.835 258.843 434 258.852C467.959 258.88 472 294.707 472 320L372 320C360.847 320 343.286 315.481 339 328L440 328L467 328C470.156 328 474.912 328.821 477.682 326.972C481.841 324.197 480 314.312 480 310C480 292.458 478.134 274.667 463.985 262.301C455.643 255.009 439.452 247.375 428 250.433C419.16 252.793 414.208 260.168 404 259.87C395.164 259.612 390.607 253.548 383 250.738C378.28 248.995 372.845 250.792 368 251M364.667 252.333L365.333 252.667L364.667 252.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cc6bc3",
      stroke: "none"
    },
    d: "M331 327C337.717 328.224 340.16 326.633 342 320L338 320C338 305.193 336.102 290.045 344.548 277C350.903 267.184 366.25 263.612 368 252C329.18 260.034 330.743 295.982 331 327M214 253L215 254L214 253M245 253L246 254L245 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ca435",
      stroke: "none"
    },
    d: "M361 253L362 254L361 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cc6bc3",
      stroke: "none"
    },
    d: "M215 254L216 255L215 254M216 255L217 256L216 255M246 255L247 256L246 255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ca435",
      stroke: "none"
    },
    d: "M356 255L357 256L356 255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cc6bc3",
      stroke: "none"
    },
    d: "M229.667 256.333L230.333 256.667L229.667 256.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ca435",
      stroke: "none"
    },
    d: "M353 257L354 258L353 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9faf1",
      stroke: "none"
    },
    d: "M28 319L87 319C104.956 319 122.976 320 141 320C145.705 320 156.561 322.01 160.397 318.972C163.478 316.532 162 308.476 162 305C161.999 289.197 157.859 273.883 144 264.599C137.903 260.514 127.432 256.199 120 258.563C112.074 261.084 106.911 266.557 98 266.961C85.6278 267.521 76.9623 258.031 66 258.059C31.378 258.145 28 293.19 28 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ca435",
      stroke: "none"
    },
    d: "M351 258L352 259L351 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9faf1",
      stroke: "none"
    },
    d: "M338 320L472 320C472 294.548 467.768 255.571 432 258.563C422.642 259.346 415.487 267.921 405 267.921C394.514 267.921 387.358 259.346 378 258.563C342.05 255.556 338 294.526 338 320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cc6bc3",
      stroke: "none"
    },
    d: "M233 259L234 260L233 259M247 259L247 264L248 264L247 259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ca435",
      stroke: "none"
    },
    d: "M350 259L351 260L350 259M347 261L348 262L347 261M362 261L363 262L362 261M346 262L347 263L346 262M360 262L361 263L360 262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cc6bc3",
      stroke: "none"
    },
    d: "M233 263L234 264L233 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ca435",
      stroke: "none"
    },
    d: "M345 263L346 264L345 263M358 263L359 264L358 263M344 264L345 265L344 264M356 264L357 265L356 264M343 265L344 266L343 265M355 265L356 266L355 265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cc6bc3",
      stroke: "none"
    },
    d: "M230 266L231 267L230 266M246.333 266.667L246.667 267.333L246.333 266.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ca435",
      stroke: "none"
    },
    d: "M342 266L343 267L342 266M341 267L342 268L341 267M352 267L353 268L352 267M351 268L352 269L351 268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cc6bc3",
      stroke: "none"
    },
    d: "M245 269L246 270L245 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ca435",
      stroke: "none"
    },
    d: "M350 269L351 270L350 269M349 270L350 271L349 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cc6bc3",
      stroke: "none"
    },
    d: "M244 271L245 272L244 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ca435",
      stroke: "none"
    },
    d: "M338 271L339 272L338 271M348 271L349 272L348 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cc6bc3",
      stroke: "none"
    },
    d: "M243 272L244 273L243 272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ca435",
      stroke: "none"
    },
    d: "M347 272L348 273L347 272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cc6bc3",
      stroke: "none"
    },
    d: "M242 273L243 274L242 273M241 274L242 275L241 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ca435",
      stroke: "none"
    },
    d: "M336 274L337 275L336 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cc6bc3",
      stroke: "none"
    },
    d: "M240 275L241 276L240 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ca435",
      stroke: "none"
    },
    d: "M345 275L346 276L345 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cc6bc3",
      stroke: "none"
    },
    d: "M238 276L239 277L238 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ca435",
      stroke: "none"
    },
    d: "M335 276L336 277L335 276M344 276L345 277L344 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cc6bc3",
      stroke: "none"
    },
    d: "M236.667 277.333L237.333 277.667L236.667 277.333M195 278L195 279L234 279C223.726 274.689 206.172 278 195 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ca435",
      stroke: "none"
    },
    d: "M334 278L335 279L334 278M343 278L344 279L343 278M342 280L343 281L342 280M341 282L342 283L341 282M332 283L333 284L332 283M340 284L341 285L340 284M331 287L332 288L331 287M339 287L340 288L339 287M338.333 291.667L338.667 292.333L338.333 291.667M330 292L330 297L331 297L330 292M192 300L193 301L192 300z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cc6bc3",
      stroke: "none"
    },
    d: "M193 301L194 302L193 301M194 302L195 303L194 302M195 303L196 304L195 303M196 304L197 305L196 304M197 305L198 306L197 305M198 306L199 307L198 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ca435",
      stroke: "none"
    },
    d: "M199 307L200 308L199 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cc6bc3",
      stroke: "none"
    },
    d: "M200 307L201 308L200 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ca435",
      stroke: "none"
    },
    d: "M330 319L330 326L331 326L330 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cc6bc3",
      stroke: "none"
    },
    d: "M247 324.432C231.302 326.499 217.82 336.157 213.761 352C207.66 375.81 227.68 401.96 253 398.711C269.692 396.568 283.825 385.096 286.674 368C290.482 345.152 271.099 321.259 247 324.432z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ca435",
      stroke: "none"
    },
    d: "M332.667 327.333L333.333 327.667L332.667 327.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9faf1",
      stroke: "none"
    },
    d: "M249 332.595C211.167 334.132 213.433 392.889 251 390.79C288.674 388.685 286.819 331.058 249 332.595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ca435",
      stroke: "none"
    },
    d: "M274 333L275 334L274 333M275 334L276 335L275 334M266 337L267 338L266 337M278 337L279 338L278 337z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cc6bc3",
      stroke: "none"
    },
    d: "M102.438 343.086C95.637 347.055 111.086 361.035 113.715 363.996C126.968 378.924 143.693 390.312 161 399.997C164.998 402.234 175.107 408.911 179.667 405.958C186.517 401.52 172.533 396.31 170 395.111C151.121 386.175 134.582 372.755 120.004 358C116.868 354.826 107.848 339.93 102.438 343.086z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ca435",
      stroke: "none"
    },
    d: "M393.999 343.137C384.664 346.977 375.832 362.897 368 369.711C353.474 382.349 336.799 388.986 321.059 399.352C318.084 401.311 315.772 406.625 321.109 407.353C326.68 408.114 335.179 401.695 340 399.244C359.676 389.241 377.259 374.616 391.711 358C393.388 356.071 404.712 338.729 393.999 343.137M274 345L275 346L274 345M284 347L285 348L284 347M285 350L286 351L285 350M277 351L278 352L277 351M286 354L287 355L286 354M278 368L279 369L278 368M286 369L287 370L286 369M285 372L286 373L285 372M284 375L285 376L284 375M274 377L275 378L274 377M281 381L282 382L281 381M278 385L279 386L278 385M238 388L239 389L238 388M261 388L262 389L261 388M274 389L275 390L274 389M246 390L247 391L246 390M253 390L254 391L253 390M270 392L271 393L270 392M259 397L260 398L259 397M254 398L255 399L254 398z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cc6bc3",
      stroke: "none"
    },
    d: "M281 476L185 476C185 451.154 188.154 413.282 223 414.304C233.328 414.607 241.365 423.81 253 423.251C263.107 422.765 269.777 415.926 279 414.292C287.214 412.837 296.096 418.368 303 422L305 414C296.755 409.68 284.633 403.96 275 406.431C266.704 408.558 261.367 415.819 252 415.819C242.544 415.82 237.247 409.202 229 406.563C220.522 403.851 208.369 408.254 201 412.313C181.034 423.311 177 442.229 177 463C177 467.849 175.179 477.427 178.028 481.566C181.42 486.495 195.721 484 201 484C221.057 484 240.95 483 261 483C269.155 483 278.649 485.664 281 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ca435",
      stroke: "none"
    },
    d: "M273 406L274 407L273 406M282 406L282 407L285 407L282 406M289 407L290 408L289 407M232 408L233 409L232 408M292 408L293 409L292 408M295 409L296 410L295 409M298 410L299 411L298 410M266 411L267 412L266 411M300 411L301 412L300 411M303 413L304 414L303 413z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9faf1",
      stroke: "none"
    },
    d: "M185 476L318 476C318 450.031 315.741 413.672 280 414.147C270.62 414.272 262.432 423.272 252 423.544C240.952 423.832 232.963 414.191 223 414.144C187.425 413.977 185 449.961 185 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ca435",
      stroke: "none"
    },
    d: "M259 414L260 415L259 414M283.667 414.333L284.333 414.667L283.667 414.333M255 415L256 416L255 415M289 415L290 416L289 415M305 415C300.852 424.914 311.789 431.22 315.373 440C319.877 451.029 318 464.309 318 476L283.225 476.318L274.956 482.852L232 483C238.194 485.599 247.314 484 254 484L302 484C307.661 484 320.061 486.312 324.566 482.397C328.821 478.699 327.002 469.032 327 464C326.993 446.282 323.27 423.148 305 415M273 416L274 417L273 416M294 417L295 418L294 417M270 418L271 419L270 418M296 418L297 419L296 418M234 419L235 420L234 419M268 419L269 420L268 419M298 419L299 420L298 419M266 420L267 421L266 420M300 420L301 421L300 420M239 421L240 422L239 421M263 421L264 422L263 421M301 421L302 422L301 421M259 422L260 423L259 422M249.667 423.333L250.333 423.667L249.667 423.333M252.667 423.333L253.333 423.667L252.667 423.333z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDb2);
export default __webpack_public_path__ + "static/media/db2.659d7b6220a903076bff42602a6de5bb.svg";
export { ForwardRef as ReactComponent };